import { render, staticRenderFns } from "./BylawsLink.vue?vue&type=template&id=332a144a"
import script from "./BylawsLink.vue?vue&type=script&lang=ts"
export * from "./BylawsLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports